const DATE_TIME = {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString(undefined, DATE_TIME) : "-");

export function formatShortDate(value) {
  if (!value) return "-";

  const parts = new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short",
  }).formatToParts(new Date(value));

  const part = (type) => parts.find((item) => item.type === type)?.value;

  return `${part("weekday")} ${part("day")} ${part("month")}`;
}

export function statusLabel(status) {
  if (!status) return "-";
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
